module.exports = __webpack_public_path__ + "static/img/virker-det.6779612.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sprites/virker-det.png
// module id = 735
// module chunks = 2